import React, { useEffect, useState } from "react";
import { showError, showSuccess } from "../../utils/toastUtils";
import { useLoader } from "../../utils/LoaderUtils";
import BannerAPI from "../../api/BannerApi";
import { useLocation, useParams } from "react-router-dom";
import ImageUploader from "../../components/partials/ImageUploader";
import { handleApiValidationError } from "../../utils/apiErrorHandler";
import SubmitButton from "../../components/partials/global/SubmitButton";

function Edit() {
  const params = useParams();
  const id = params.id || {};

  const { showLoader, hideLoader } = useLoader();
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    title: "",
    subtitle: "",
    redirectUrl: "",
    position: "",
    image: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleImageUploadSuccess = (type, url) => {
    setFormData((prev) => ({
      ...prev,
      [type]: url,
    }));
  };

  useEffect(() => {
    fetchSingleDetails();
  }, []);

  const fetchSingleDetails = async () => {
    try {
      const res = await BannerAPI.getSingleDetails(id);

      if (res.code === 200) {
        const result = res.data;

        setFormData({
          title: result.title,
          subtitle: result.subTitle,
          redirectUrl: result.redirectUrl,
          position: result.position,
          image: result.image,
        });
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.position) {
      newErrors.position = "Position Field is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    showLoader();

    if (!validate()) {
      setIsLoading(false);
      hideLoader();
      return;
    }

    try {
      const res = await BannerAPI.updateDetails(id, formData);

      if (res.code === 200) {
        showSuccess(res.message);
      } else {
        showError(res.message);
      }
    } catch (err) {
      handleApiValidationError(err, setErrors);
    }

    setIsLoading(false);
    hideLoader();
  };

  return (
    <>
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Edit Store Banner</h4>
            <h6>
              Update your banner’s content, image, or placement to ensure
              optimal performance.
            </h6>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h4>Edit Details</h4>
          </div>
          <div className="card-body profile-body">
            <form method="post" onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-6 col-sm-12">
                  <label className="form-label">
                    Banner <span className="text-danger">*</span>
                  </label>
                  <ImageUploader
                    type="image"
                    label="Banner"
                    value={formData.image}
                    onUploadSuccess={handleImageUploadSuccess}
                    assetType="banners"
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Title</label>
                    <div className="input-group">
                      <span className="input-group-text" id="basic-addon1">
                        <i className="fa fa-pencil"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Title"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                      />
                    </div>
                    {errors.title && (
                      <span className="errors text-danger">{errors.title}</span>
                    )}
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">SubTitle</label>
                    <div className="input-group">
                      <span className="input-group-text" id="basic-addon1">
                        <i className="fa fa-pencil"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="SubTitle"
                        name="subtitle"
                        value={formData.subtitle}
                        onChange={handleChange}
                      />
                    </div>
                    {errors.subTitle && (
                      <span className="errors text-danger">
                        {errors.subTitle}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Redirect Url</label>
                    <div className="input-group">
                      <span className="input-group-text" id="basic-addon1">
                        <i className="fa fa-globe"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        name="redirectUrl"
                        placeholder="Redirect Url"
                        value={formData.redirectUrl}
                        onChange={handleChange}
                      />
                    </div>
                    {errors.redirectUrl && (
                      <span className="errors text-danger">
                        {errors.redirectUrl}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Position</label>
                    <div className="input-group">
                      <span className="input-group-text" id="basic-addon1">
                        <i className="fa fa-location"></i>
                      </span>
                      <select
                        value={formData.position}
                        className="form-select"
                        name="position"
                        onChange={handleChange}
                      >
                        <option value="top">Top</option>
                        <option value="middle">Middle</option>
                      </select>
                    </div>
                    {errors.position && (
                      <span className="errors text-danger">
                        {errors.position}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 d-flex justify-content-end">
                  <SubmitButton
                    isLoading={isLoading}
                    text="Submit Details"
                    loadingText="Submitting..."
                  ></SubmitButton>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Edit;
